import Vue from 'vue'
import SvgIcon from '@/components/SvgIcon'// svg

// register globally
Vue.component('svg-icon', SvgIcon)

const requireAll = requireContext => requireContext.keys().map(requireContext)
const req = require.context('./svg', false, /\.svg$/)
requireAll(req)



// WEBPACK FOOTER //
// ./src/icons/index.js